// External libraries
import { useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';

// CSS
import '../styles/main.css';

// Components
import { Button, ButtonTheme, ButtonSize, ButtonVariant, Heading, TypographyType, TypographyColor, Body, BodyType, BodyColor, } from '../ui-elements';
import {RequestData} from '../components/home';

// Utilities
import { geoState, selectedGeoNameState } from '../states';

const NoPoi = () => {
    const [isOpenDrawer, setIsOpenDrawer] = useState(false);
    const selectedGeoName = useRecoilValue(selectedGeoNameState);
    const setSelectedGeo = useSetRecoilState(geoState);

    const requestPoiData = () => {
        setIsOpenDrawer(true);
    }

    const handleBack = () => {
        setSelectedGeo({ country: 'EW-IN-IND-22-0', state: '', district: '', sub_district: '', village: '' });
    }

    return (
        <div style={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', marginTop: '3%' }} >
            <div className='bg-white' style={{ height: '100%', width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <div className="noPoiBackgroundImage">
                    <div className='position-absolute d-flex flex-column justify-content-center align-items-center ' style={{ top: '60%', }}>
                        <Heading
                            title='Work in progress.'
                            type={TypographyType.h2}
                            colour={TypographyColor.primary}
                            classname='text-center margin-top-bottom-2'
                        />
                        <Body
                            type={BodyType.p1}
                            color={BodyColor.secondary}
                            classname='margin-bottom-3 text-center'
                        >
                            We’re currently adding these insights across vibrant locations in India. Let us know if you’d like this location to be prioritized.
                        </Body>
                        <div className='d-flex flex-column justify-content-center align-items-center w-75'>
                            <Button
                                theme={ButtonTheme.primary}
                                size={ButtonSize.large}
                                variant={ButtonVariant.bordered}
                                type='button'
                                onClick={requestPoiData}
                                classname='margin-top-3 height-3rem'
                            >
                                Request data coverage
                            </Button>
                            <Button
                                theme={ButtonTheme.primary}
                                size={ButtonSize.large}
                                variant={ButtonVariant.transparent}
                                type='button'
                                onClick={handleBack}
                                classname='margin-top-3 height-3rem'
                            >
                                <u>Return to India</u>
                            </Button>
                        </div>

                    </div>
                </div>
            </div>
            <RequestData isOpen={isOpenDrawer} setIsOpen={setIsOpenDrawer} geoName={selectedGeoName} subHeading={`If you like to request data for “${selectedGeoName}”, fill the following form to request this. We will engage with you to prioritize this geography of interest, and notify you once the data has been updated.`} purpose="PoI coverage" />
        </div>
    )
}

export default NoPoi
